import { get } from '@helpcenter/ajax';
import { contextPath } from '@atlassian/help-center-common-util/history';
import type { GetRequestCreatePropertyResponse } from './types';

export const getRequestCreateProperty = ({
	requestKey,
	propertyKey,
	extensionId,
	context = contextPath,
}: {
	requestKey: string;
	propertyKey: string;
	context?: string;
	extensionId: string;
}): Promise<GetRequestCreatePropertyResponse> => {
	const uri = `${context}/rest/api/3/issue/${requestKey}/properties/${propertyKey}`;
	// Suppressing existing violation. Please fix this.
	// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	return get(uri)
		.toPromise()
		.then((ajaxResponse) => {
			// Suppressing existing violation. Please fix this.
			// eslint-disable-next-line @typescript-eslint/no-unsafe-return
			return { extensionId, ...ajaxResponse.response };
		})
		.catch((e) => Promise.reject(e));
};
